// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a3e00c4a] .button{align-items:center;display:flex;font-size:.875rem;margin:0}[data-v-a3e00c4a] .button .icon{bottom:1px;flex:0 0 auto}[data-v-a3e00c4a] .icon-facebook{color:#3b5998}[data-v-a3e00c4a] .icon-twitter{color:#55acee}[data-v-a3e00c4a] .icon-pinterest{color:#c8232c}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
